import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class TeleFuHsmMarketingEffectivityRateMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"EFektifitas FU HSM Marketing"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(lead => {
                            return (
                            <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={8}>
                                        <strong>{lead.salesName}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        <strong>{lead.leadsCount} FU</strong>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        <strong>Lavender</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        <strong>HSM</strong>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <strong>FU</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {lead.fromLavender.length}
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {lead.fromHsm.length}
                                    </Grid>
                                    
                                    <Grid item xs={4}>
                                        <strong>Respon</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {lead.totalAdaResponLavender}
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {lead.totalAdaResponHsm}
                                    </Grid>

                                    <Grid item xs={4}>
                                        <strong>Rate</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {(lead.responRateLavender*100).toFixed(2).replace(".00", "")}%
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        {(lead.responRateHsm*100).toFixed(2).replace(".00", "")}%
                                    </Grid>
                                </Grid>

                                <Divider sx={{mt: "8px"}} />
                            </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default TeleFuHsmMarketingEffectivityRateMobile;